import { filterKeyMap } from '../hooks/urlFilterNavigator';
import { FilterData } from '../types';

import { FILTER_KEYS } from './constants';

export const parseFiltersFromUrl = (url: string): FilterData => {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);
  const filters: FilterData = {};

  Array.from(params.entries()).forEach(([key, value]) => {
    const mappedKey = filterKeyMap[key] || key;
    (filters as any)[mappedKey] = value;
  });

  return filters;
};

export function filterNonEmpty(obj: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) =>
        value !== null &&
        value !== undefined &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(Array.isArray(value) && value.length === 0)
    )
  );
}

export const filterAllowedKeys = (
  baseFilters: Record<string, any>,
  initialResponse: boolean,
  isDisplayed?: boolean
): FilterData => {
  const hasFullName =
    baseFilters.fullName &&
    baseFilters.fullName !== '' &&
    baseFilters.fullName !== '0';
  const allowedKeys = [
    FILTER_KEYS.age,
    FILTER_KEYS.location,
    FILTER_KEYS.city,
    FILTER_KEYS.state,
    FILTER_KEYS.country,
    FILTER_KEYS.address,
    FILTER_KEYS.company,
  ];
  if (!isDisplayed) {
    allowedKeys.push(FILTER_KEYS.source);
    allowedKeys.push(FILTER_KEYS.advanced_search);
  }
  if (hasFullName && initialResponse) {
    allowedKeys.push(FILTER_KEYS.fullName);
  } else {
    allowedKeys.push(FILTER_KEYS.fName, FILTER_KEYS.mName, FILTER_KEYS.lName);
  }
  if (!initialResponse) {
    allowedKeys.push(
      FILTER_KEYS.company,
      FILTER_KEYS.industry,
      FILTER_KEYS.title,
      FILTER_KEYS.deathYear,
      FILTER_KEYS.deathMonth,
      FILTER_KEYS.birthYear,
      FILTER_KEYS.birthMonth,
      FILTER_KEYS.city,
      FILTER_KEYS.state
    );
  }
  return Object.entries(baseFilters)
    .filter(
      ([key, value]) =>
        allowedKeys.includes(key) &&
        value !== '' &&
        value !== '0' &&
        value !== 0
    )
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};
